import { WorkloadRecommendationStatusTypeEnum } from '@cast/types';

import type { PreparedWorkload } from 'features/workload-optimization/types';

export const hasLowConfidence = (workload: PreparedWorkload): boolean =>
  workload.recommendationStatus.lowConfidence;

export const hasError = (workload: PreparedWorkload): boolean =>
  !!workload.recommendationStatus.error;

export const isAppliedWithPods = (workload: PreparedWorkload): boolean =>
  workload.recommendationStatus.type ===
    WorkloadRecommendationStatusTypeEnum.APPLIED &&
  workload.recommendationStatus.totalPods > 0;

export const isStopped = (workload: PreparedWorkload): boolean =>
  workload.recommendationStatus.type ===
  WorkloadRecommendationStatusTypeEnum.STOPPED;

// BE returns STATUS_UNKNOWN when vertical autoscaling is disabled (or no
// recommendation has been produced yet). Treated as "no recommendation has
// been applied" regardless of per-pod isLatestRecommendation / appliedAt.
//
// Accepts the structural minimum so it can be used with both
// `PreparedWorkload` (workload-details drawer / workloads list) and the raw
// `OptimizationWorkload` (cost-report drawer).
export const isWorkloadOptimizationDisabled = (
  workload:
    | Pick<PreparedWorkload, 'recommendationStatus'>
    | { recommendationStatus?: { type?: WorkloadRecommendationStatusTypeEnum } }
    | undefined
): boolean => {
  const type = workload?.recommendationStatus?.type;
  return type === WorkloadRecommendationStatusTypeEnum.UNKNOWN;
};
